import { ThemeUICSSObject } from '@apia/theme';

export const getFieldErrorStyles = (isValid: boolean): ThemeUICSSObject => {
  return {
    borderLeftStyle: !isValid ? 'solid' : null,
    borderLeftWidth: !isValid ? '4px' : null,
    borderLeftColor: !isValid ? 'danger' : undefined,
  };
};

export const getFieldTouchedStyles = (isTouched: boolean): ThemeUICSSObject => {
  return {
    borderStyle: isTouched ? 'solid' : null,
    borderWidth: isTouched ? '1px' : null,
    borderColor: isTouched ? 'touchedBorderColor' : undefined,
  };
};
